import { cn } from "@/lib/utils";

interface Props {
  children: React.ReactNode;
  className?: string;
  tone?: "mint" | "butter" | "peach";
}

const toneMap = {
  mint: "text-mint border-mint/30 bg-mint/10",
  butter: "text-butter border-butter/30 bg-butter/10",
  peach: "text-peach border-peach/30 bg-peach/10",
} as const;

const dotMap = {
  mint: "bg-mint",
  butter: "bg-butter",
  peach: "bg-peach",
} as const;

export function LivePulseBadge({ children, className, tone = "mint" }: Props) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 rounded-full border px-3 py-1 text-[11px] font-medium uppercase tracking-[0.18em] backdrop-blur-sm",
        toneMap[tone],
        className,
      )}
    >
      <span className="relative inline-flex h-2 w-2">
        <span
          className={cn(
            "absolute inset-0 inline-flex h-full w-full animate-ping rounded-full opacity-75",
            dotMap[tone],
          )}
        />
        <span className={cn("relative inline-flex h-2 w-2 rounded-full", dotMap[tone])} />
      </span>
      {children}
    </span>
  );
}
